// extracted by mini-css-extract-plugin
export default {"right":"TVPageRight_right__GvjCf","rightDiv":"TVPageRight_rightDiv__tRBnZ"};